import { Api } from 'models/services/api';
import { DeleteOriginalIngredientCategoryQuery } from 'models/services/graphql';

import { OriginalIngredientCategoryData } from '../index';

type DataToDelete = {
  id: string;
};

const RequestQuery = `
  mutation DeleteOriginalIngredientCategory($id: ID!) {
    ${DeleteOriginalIngredientCategoryQuery}
  }
`;

type ResponseData = {
  data: {
    deleteOriginalIngredientCategory: OriginalIngredientCategoryData
  }
}

class DeleteGql {

  readonly api: Api<ResponseData>;
  readonly document?: OriginalIngredientCategoryData;

  constructor() {
    this.api = new Api<ResponseData>(RequestQuery);
  }

  async fetch(data: DataToDelete): Promise<this> {
    const api = await this.api.fetch({ variables: data });
    if (!api.response) throw 'invalid response';
    const document = api.response.data.deleteOriginalIngredientCategory;
    return Object.assign(Object.create(this.constructor.prototype), { ...this, api, document });
  }

}

export { DeleteGql };